// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3xDGJ","tab":"ProcedureTabs_tab__3IWtU"};